import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Payment Integration
  paymentIntegration: null,
  loadingPayment: false,
  errorLoadingPayment: null,
  loadingUpdatePayment: false,
  errorUpdatingPayment: null,

  // Fiscal Integration
  fiscalIntegration: null,
  loadingFiscal: false,
  errorLoadingFiscal: null,
  loadingUpdateFiscal: false,
  errorUpdatingFiscal: null,

  serverStatus: null,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    // --- Payment Integration ---
    setLoadingPayment(state) {
      state.loadingPayment = true;
      state.errorLoadingPayment = null;
    },
    setErrorLoadingPayment(state, { payload }) {
      state.loadingPayment = false;
      state.errorLoadingPayment = payload;
    },
    setPaymentIntegration(state, { payload }) {
      state.loadingPayment = false;
      state.paymentIntegration = payload;
    },
    setLoadingUpdatePayment(state) {
      state.loadingUpdatePayment = true;
      state.errorUpdatingPayment = null;
    },
    setErrorUpdatingPayment(state, { payload }) {
      state.loadingUpdatePayment = false;
      state.errorUpdatingPayment = payload;
    },
    updatePaymentSuccess(state, { payload }) {
      state.loadingUpdatePayment = false;
      state.paymentIntegration = payload;
    },

    // --- Fiscal Integration ---
    setLoadingFiscal(state) {
      state.loadingFiscal = true;
      state.errorLoadingFiscal = null;
    },
    setErrorLoadingFiscal(state, { payload }) {
      state.loadingFiscal = false;
      state.errorLoadingFiscal = payload;
    },
    setFiscalIntegration(state, { payload }) {
      state.loadingFiscal = false;
      state.fiscalIntegration = payload;
    },
    setLoadingUpdateFiscal(state) {
      state.loadingUpdateFiscal = true;
      state.errorUpdatingFiscal = null;
    },
    setErrorUpdatingFiscal(state, { payload }) {
      state.loadingUpdateFiscal = false;
      state.errorUpdatingFiscal = payload;
    },
    updateFiscalSuccess(state, { payload }) {
      state.loadingUpdateFiscal = false;
      state.fiscalIntegration = payload;
    },

    setServerResponseStatus(state, { payload }) {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingPayment,
  setErrorLoadingPayment,
  setPaymentIntegration,
  setLoadingUpdatePayment,
  setErrorUpdatingPayment,
  updatePaymentSuccess,
  setLoadingFiscal,
  setErrorLoadingFiscal,
  setFiscalIntegration,
  setLoadingUpdateFiscal,
  setErrorUpdatingFiscal,
  updateFiscalSuccess,
  setServerResponseStatus,
} = settingsSlice.actions;

export default settingsSlice.reducer;
